module.exports = __webpack_public_path__ + "0b1347289ae4988ce118d23829afe170.png";